import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferActionTypes } from '../../store/actions/transfer-actions';
import { TransferService } from '../../services/transfer.service';
import { UdeuService } from '../../services/udeu.service';
import { PipeServiceImpl } from 'pipe-service/pipe-service-impl';

@Component({
    templateUrl: './transfers.component.html',
    styleUrls: ['./transfers.component.scss'],
})
export class TransfersComponent implements OnInit, OnDestroy {

    //Nombre de la confituración del visor en el json
    viewerConfigId: string = "deusto-transfers-viewer";

    constructor(private route: ActivatedRoute, private router: Router, private transferService: TransferService, 
        private udeuService: UdeuService, private pipeService: PipeServiceImpl) {}

    ngOnInit(): void {
        const UUID = this.route.snapshot.paramMap.get('uuid');
        if(UUID) {
            // Eliminar el parámetro de la URL
            this.router.navigate(['../'], { relativeTo: this.route }); 
            // Abrimos la transferencia
            this.transferService.openCreateTransfer(UUID, TransferActionTypes.EditTransfer, true);
        }

        this.udeuService.getPersonDetails();
    }

    ngOnDestroy(): void {
        // Necesitamos limpiar los maps por si han actualizado algún valor
        this.pipeService.refreshMaps();
    }

}